import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputNumberComponent } from './input-number.component';
import { FormsModule } from '@angular/forms';
import {NumberOnlyModule} from '../../../../../shared/directives';


@NgModule({
  declarations: [InputNumberComponent],
  imports: [
    CommonModule,
    FormsModule,
    NumberOnlyModule,
  ],
  exports: [
    InputNumberComponent
  ]
})
export class InputNumberModule { }
